import type { DeepString } from "@/lib/i18n";

/**
 * WSearch - polskie tłumaczenia (ikona + modal wyszukiwarki z autocomplete).
 *
 * `groupLabel(key)` - etykieta grupy podpowiedzi (`catalogs`/`products`/`articles`).
 */
const GROUP_LABELS: Record<string, string> = {
  catalogs: "Katalogi",
  products: "Produkty",
  articles: "Artykuły",
};

export const pl = {
  open: "Otwórz wyszukiwarkę",
  title: "Wyszukiwarka",
  close: "Zamknij",
  searchLabel: "Wyszukiwarka",
  inputLabel: "Szukaj",
  placeholder: "Szukaj produktów, kategorii, stron...",
  suggestionsLabel: "Podpowiedzi",
  loading: "Szukam...",
  popularLabel: "Popularne wyszukiwania",
  notConfigured: "Wyszukiwarka nie jest skonfigurowana (brak strony wyników).",
  groupLabel: (key: string): string => GROUP_LABELS[key] ?? key,
} as const;

export type WSearchTranslations = DeepString<typeof pl>;
